let url = "";
let calendarRedirectURL = "";
let isGalaxPayInProd = false;
let politicasPrivacidadeURL = "";
let termosUsoURL = "";
let webPushPublicKey = "";
let googleClientId = "";
let barbeiroUrl = "";

if (process.env.NODE_ENV === "development") {
  url = process.env.REACT_APP_BACKEND_URL;
  calendarRedirectURL = url + "/api/barbeiro/google/auth";
  barbeiroUrl = process.env.REACT_APP_FRONTEND_BARBEIRO_URL;
  politicasPrivacidadeURL = barbeiroUrl + "/politica-de-privacidade";
  termosUsoURL = barbeiroUrl + "/termos-de-uso";
  webPushPublicKey = process.env.REACT_APP_WEB_PUSH_PUBLIC_KEY;
  googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
} else if (process.env.REACT_APP_STAGE === "homolog") {
  url = "https://dev.api.cashbarber.com.br";
  calendarRedirectURL =
    "https://dev.api.cashbarber.com.br/api/barbeiro/google/auth";
  politicasPrivacidadeURL =
    "https://dev.profissional.cashbarber.com.br/politica-de-privacidade";
  termosUsoURL = "https://dev.profissional.cashbarber.com.br/termos-de-uso";
  webPushPublicKey =
    "BMf5GAN0LPUsaALujaqaM_i29Y0iPHlm3ncvgPYPdKJuielV2iU91qM-Iz0wuh8UXL7KV_jQYZyNzKvekuwpAsk";
  googleClientId =
    "318754238400-mp9hokoa0r82mgip4nnndfbjr2h72rik.apps.googleusercontent.com";
} else {
  url = "https://api.cashbarber.com.br";
  calendarRedirectURL =
    "https://api.cashbarber.com.br/api/barbeiro/google/auth";
  politicasPrivacidadeURL =
    "https://profissional.cashbarber.com.br/politica-de-privacidade";
  termosUsoURL = "https://profissional.cashbarber.com.br/termos-de-uso";
  isGalaxPayInProd = true;
  webPushPublicKey =
    "BMf5GAN0LPUsaALujaqaM_i29Y0iPHlm3ncvgPYPdKJuielV2iU91qM-Iz0wuh8UXL7KV_jQYZyNzKvekuwpAsk";
  googleClientId =
    "318754238400-mp9hokoa0r82mgip4nnndfbjr2h72rik.apps.googleusercontent.com";
}

export const Constants = {
  url: url,
  baseUrl: `${url}/api/barbeiro`,
  pumpUrl: `${url}/api/pump`,
  calendarRedirectURL,
  google_client_id: googleClientId,
  isGalaxPayInProd,
  webPushPublicKey,
  politicasPrivacidadeURL,
  termosUsoURL,
};
